const PICKS = [
  { tag: "现场视频", num: "247", unit: "段在更" },
  { tag: "实拍图证", num: "1.2w", unit: "张归档" },
  { tag: "截图线索", num: "386", unit: "条对表" },
];

export default function Hero() {
  return (
    <section className="relative paper-grain overflow-hidden pt-28 md:pt-36 pb-14 md:pb-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          {/* copy block */}
          <div className="flex flex-col justify-center lg:col-span-7">
            <div className="inline-flex items-center gap-2 self-start rounded-full border border-foreground-200 bg-background-100/70 px-3.5 py-1.5 text-[12px] tracking-wide text-foreground-600">
              <span className="inline-flex h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse" />
              911网 · 本期纵览
            </div>

            <h1 className="mt-6 font-serif text-[34px] leading-[1.18] font-black text-foreground-950 md:text-[52px] md:leading-[1.12]">
              眼见为凭，
              <br />
              线索<span className="text-primary-500">同场</span>对表看。
            </h1>

            <p className="mt-6 max-w-xl text-[15px] leading-7 text-foreground-500 md:text-base md:leading-8">
              911网把现场视频、实拍画面与目击者说、截图线索按事件归到一处。
              想弄清来龙去脉，不必隔着二手转述猜测真假——直接对照画面与细节，自己拿主意。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#feed"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                看现场速递
                <i className="ri-arrow-right-line text-[15px]" aria-hidden="true" />
              </a>
              <a
                href="#docs"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-foreground-300/80 bg-background-50 px-5 py-3 text-sm text-foreground-700 transition-colors hover:border-foreground-950 hover:text-foreground-950 whitespace-nowrap"
              >
                翻图证档案
              </a>
            </div>
          </div>

          {/* restrained visual */}
          <div className="lg:col-span-5">
            <div className="relative lg:mt-2">
              <figure className="overflow-hidden rounded-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20composition%20of%20translucent%20warm%20paper%20sheets%20layered%20with%20a%20thin%20vermilion%20red%20light%20streak%20diagonal%2C%20soft%20studio%20gradient%2C%20cream%20and%20ivory%20tones%2C%20newspaper%20archive%20vibe%2C%20calm%20negative%20space%2C%20high%20key%20lighting%2C%20clean%20and%20quiet%20visual%20mood&width=1000&height=1240&seq=hero-911-a1&orientation=portrait"
                  alt="911网现场档案影像示例"
                  title="911网现场档案 · 影像素材"
                  className="h-[380px] w-full object-cover object-top md:h-[460px]"
                />
              </figure>
              <div className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-[11px] tracking-wider text-foreground-700 backdrop-blur">
                现场影像档案 · 持续归档
              </div>
              <figcaption className="mt-3 text-[12px] leading-5 text-foreground-400">
                素材仅作版式示意，栏内影像以现场实拍与截图为主，按事件分组铺陈。
              </figcaption>
            </div>
          </div>
        </div>

        {/* stat strip */}
        <div className="mt-12 md:mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-foreground-200 bg-foreground-200 sm:grid-cols-3">
          {PICKS.map((p) => (
            <div key={p.tag} className="flex items-baseline justify-between bg-background-100 px-5 py-4">
              <span className="text-[13px] text-foreground-500">{p.tag}</span>
              <span className="flex items-baseline gap-1.5">
                <span className="font-serif text-2xl font-bold text-primary-600">{p.num}</span>
                <span className="text-[12px] text-foreground-400">{p.unit}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}